import React from "react";
import Container from "components/atoms/layout/Container/Container";
import PulseBody from "./components/table";
import { Filter } from "components/atoms/Filter";
import { ExportSelected } from "components/layouts/exportSelected";
import { PulseHeader } from "components/modules/Pulse/components/header";
import { Footer } from "components/molecules/TableFooter";
import { useAppSelector } from "store/hooks";
import { usePulse } from "./model/usePulse";


const PulseModule: React.FC<{ formEnrichment: boolean }> = ({ formEnrichment }) => {
  const { filters, pageSize } = usePulse({ formEnrichment })
  const { insights, ui } = useAppSelector((state) => state);

  return <Container direction='row' className='flex flex-1 gap-5 flex-row  overflow-hidden'>
    <div className={`flex py-4 px-5 flex-1 gap-5 overflow-hidden ${ui.filterOpen ? 'flex-row' : 'flex-col'}`}>
      <Filter filters={filters} />
      <div className="flex flex-col h-full overflow-hidden w-full border border-gray-700 bg-gray-800 rounded-2xl">
        <PulseHeader />
        <PulseBody />
        <Footer totalItems={insights.leads.count} pageSize={pageSize} />
      </div>
    </div>
    {ui.exportOpen ? <ExportSelected /> : null}
  </Container>
};
export default PulseModule;

